module.exports = __webpack_public_path__ + "img/29c4f1a.png";